module.exports = __webpack_public_path__ + "static/media/studentType.5ff36b86.jpg";